import axios from 'axios'

import { IEstablishment } from '../../../Establishment/interface/IEstablishment'
import { IUser } from '../../DataStore/IUser'

class LoginClient {
  static login(
    establishment: IEstablishment,
    user: IUser,
    password: string,
    rememberMe: string,
  ) {
    const formData = new FormData()
    formData.append('_username', String(user.id))
    formData.append('_password', password)
    formData.append('optios_id', String(establishment.id))
    formData.append('_remember_me', rememberMe)

    return axios.post('/login', formData, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
  }

  static loginAsPartner(optiosId: string, email: string, password: string) {
    const formData = new FormData()
    formData.append('_username', email)
    formData.append('_password', password)
    formData.append('optios_id', optiosId)

    return axios.post('/login', formData, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
  }
}

export default LoginClient
